<template>
    <b-button
        :block="block"
        :class="{'placeholder-label': label === false }"
        :disabled="disabled"
        :size="size"
        :title="title"
        :to="to"
        :variant="(outline ? 'outline-' : '') + color"
        @click="$emit('click', $event)"
        v-rkm-tooltip.hover
    >
        <slot />
    </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
    components: { BButton },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
    },
    props: {
        block: { type: Boolean },
        color: { type: String, default: 'secondary' },
        disabled: { type: Boolean },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean },
        outline: { type: Boolean },
        small: { type: Boolean },
        title: { type: String, default: '' },
        to: { type: [Object, String] },
    },
}
</script>